import { VerticalSynchronizedCrosshair } from '../../../core/components/shared-chart-interactions/components/VerticalSynchronizedCrosshair.js';
import { useSynchronizedCrosshair } from '../../../core/components/shared-chart-interactions/hooks/useSynchronizedCrosshair.js';
import { useVisibleXAxisByPriority } from '../../hooks/useVisibleXAxisByPriority.js';
import { useXYChartId } from '../../hooks/useXYChartId.js';
import { isTimeScale } from '../../types/guards.js';

export function XYChartSynchronizedCrosshair() {
  const synchronizedCrosshair = useSynchronizedCrosshair();
  const chartId = useXYChartId();
  const syncXAxes = useVisibleXAxisByPriority();

  if (!synchronizedCrosshair) {
    return null;
  }

  const { hoveredChartId, disabled: synchronizedCrosshairDisabled } =
    synchronizedCrosshair ?? {};

  const showVerticalCrosshair =
    hoveredChartId !== chartId && !synchronizedCrosshairDisabled;

  if (!(showVerticalCrosshair && isTimeScale(syncXAxes))) {
    return null;
  }

  return <VerticalSynchronizedCrosshair scale={syncXAxes.axisScale} />;
}

XYChartSynchronizedCrosshair['displayName'] = 'XYChartSynchronizedCrosshair';
